import React from "react";
import "./ProductMetaBadges.scss";

const ProductMetaBadges = ({
	productForm,
	packageLabel,
	quantity,
	packagingDetail,
	stock,
	qtyLabel = "Qty",
	stockLabel = "Stock",
	variant = "default",
	className = "",
}) => {
	const showPackagingDetail = packagingDetail && variant !== "card";
	const hasAny =
		productForm ||
		packageLabel ||
		quantity != null ||
		showPackagingDetail ||
		(stock != null && variant !== "card");

	if (!hasAny) return null;

	const stockNum = stock != null ? Number(stock) : null;
	const isZeroStock = stockNum === 0;
	const showPackage =
		packageLabel &&
		(!productForm || packageLabel.toLowerCase() !== productForm.toLowerCase());

	return (
		<div className={`product-meta-badges product-meta-badges--${variant} ${className}`.trim()}>
			{productForm ? (
				<span className="product-meta-badge product-meta-badge--form" title={productForm}>
					{productForm}
				</span>
			) : null}
			{showPackage ? (
				<span className="product-meta-badge product-meta-badge--package" title={packageLabel}>
					{packageLabel}
				</span>
			) : null}
			{quantity != null ? (
				<span className="product-meta-badge product-meta-badge--qty" title={`${qtyLabel}: ${quantity}`}>
					{variant === "card" ? `×${quantity}` : `${qtyLabel}: ${quantity}`}
				</span>
			) : null}
			{showPackagingDetail ? (
				<span className="product-meta-badge product-meta-badge--detail" title={packagingDetail}>
					{packagingDetail}
				</span>
			) : null}
			{stock != null && variant !== "card" ? (
				<span
					className={`product-meta-badge product-meta-badge--stock${
						isZeroStock ? " is-zero" : ""
					}`}
				>
					{stockLabel}: {stock}
				</span>
			) : null}
		</div>
	);
};

export default ProductMetaBadges;
